module.exports = __webpack_public_path__ + "img/settings.57117252.png";